import React from 'react';

import classNames from 'classnames';
import Truncate from 'react-truncate';
import { useTranslation } from 'react-i18next';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { formatDate } from '../../../../helpers/dates';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';
import calculateReadingTime from '../../../../helpers/calculateReadingTime';
import { WysiwygField, AngledSquare, CoreLink } from '../../../../components';
import './style.scss';

const NodeKPAnswerPageTeaser = ({ entity, className }) => {

  const { t } = useTranslation();
  const created = entity.getIn(['created', 0, 'value']);
  const classes = classNames(className, 'KPAnswerPage', {
  });

  const publicationDate = formatDate(new Date(created), 'd MMMM yyyy');
  const answerType = entity.getIn(['field_type_of_answer', 0, 'entity', 'name', 0, 'value'], '');
  const readingTime = entity.getIn(['field_reading_time'], 0);

  const readingTypes = [
    'Longread',
    'Blog',
    'Shortread',
  ];

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="News teaser NodeKPAnswerPageTeaser">
        <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="overlapping-link">
          <div>
            <div className="NodeKPAnswerPageTeaser__image">
              <Image
                alt={entity.getIn(['title', 0, 'value'])}
                src={{
                  0: entity.getIn(['field_image', 0, 'styles', 'teaser_image']),
                  768: entity.getIn(['field_image', 0, 'styles', 'large_teaser_image']),
                }}
                includeWebP
              />
              <div className="NodeKPAnswerPageTeaser__angledsquareIcon">
                <span className={`icon icon-${answerType.toLowerCase()} icon-variant-4`} />
                <span className="answertype">{answerType}</span>
              </div>
              <AngledSquare size="100px" />
            </div>

            <div className="NodeKPAnswerPageTeaser__metadata">
              {readingTypes.includes(answerType) && (
                <span className="reading-time">
                  {t('reading_time')} {calculateReadingTime(readingTime)} min.
                </span>
              )}
            </div>

            <h3 className="NodeKPAnswerPageTeaser__title">
              <div>
                <Truncate lines={2} ellipsis="..." trimWhitespace>
                  {entity.getIn(['title', 0, 'value'])}
                </Truncate>
              </div>
            </h3>

            <div className="NodeKPAnswerPageTeaser__body">
              <WysiwygField
                property="schema:text"
                className="NodeKPAnswerPageTeaser__body"
                html={entity.getIn(['body', 0, 'processed'], '')}
              />
            </div>
          </div>
        </CoreLink>
      </div>
    </article>
  );
};

export default NodeKPAnswerPageTeaser;
